(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-block-ch-comprar"] && !Shopify.designMode) return;
  try {
    document.addEventListener('ts:variant', function (e) {
  var d = e.detail || {}, v = d.variant;
  document.querySelectorAll('[data-ch-buy][data-section="' + d.section + '"]').forEach(function (el) {
    var btn = el.querySelector('[data-ch-btn]'), txt = el.querySelector('[data-ch-btn-txt]');
    if (!v) { btn.disabled = true; txt.textContent = el.getAttribute('data-unavailable'); return; }
    var inp = el.querySelector('form input[name="id"]'); if (inp) inp.value = v.id;
    btn.disabled = !v.available;
    btn.removeAttribute('aria-disabled');
    txt.textContent = v.available ? el.getAttribute('data-add') : el.getAttribute('data-soldout');
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-block-ch-envio"] && !Shopify.designMode) return;
  try {
    (function () {
  function init(el) {
    if (el.__ch) return; el.__ch = true;
    var dias = parseInt(el.getAttribute('data-dias'), 10) || 0;
    var finde = el.getAttribute('data-finde') === 'true';
    var sem = (el.getAttribute('data-semana') || '').split(',').map(function (x) { return x.trim(); });
    var mes = (el.getAttribute('data-meses') || '').split(',').map(function (x) { return x.trim(); });
    if (sem.length < 7 || mes.length < 12) return;
    var d = new Date();
    if (finde) {
      var r = dias;
      while (r > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) r--; }
    } else {
      d.setDate(d.getDate() + dias);
    }
    var out = el.querySelector('[data-ch-ship-date]');
    if (out) out.textContent = sem[d.getDay()] + ' ' + d.getDate() + '. ' + mes[d.getMonth()];
  }
  function boot() { document.querySelectorAll('[data-ch-ship]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-block-ch-precio"] && !Shopify.designMode) return;
  try {
    document.addEventListener('ts:variant', function (e) {
  var d = e.detail || {}, v = d.variant;
  document.querySelectorAll('[data-ch-price][data-section="' + d.section + '"]').forEach(function (el) {
    if (!v) return;
    var map = {};
    try { map = JSON.parse(el.querySelector('[data-ch-price-map]').textContent); } catch (err) { return; }
    var p = map[String(v.id)]; if (!p) return;
    var oldEl = el.querySelector('[data-ch-old]'), newEl = el.querySelector('[data-ch-new]'), badge = el.querySelector('[data-ch-badge]');
    newEl.textContent = p.p;
    oldEl.textContent = p.c; oldEl.hidden = !p.c;
    if (badge) { badge.textContent = p.s ? el.getAttribute('data-badge').replace('[amount]', p.s) : ''; badge.hidden = !p.s; }
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-block-ch-stock"] && !Shopify.designMode) return;
  try {
    (function () {
  function init(el) {
    if (el.__ch) return; el.__ch = true;
    var n = el.querySelector('[data-ch-stock-n]');
    if (el.getAttribute('data-modo') !== 'real') {
      var a = parseInt(el.getAttribute('data-min'), 10) || 1, b = parseInt(el.getAttribute('data-max'), 10) || a;
      if (b < a) { var t = a; a = b; b = t; }
      n.textContent = Math.floor(Math.random() * (b - a + 1)) + a;
    }
  }
  function boot() { document.querySelectorAll('[data-ch-stock]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('ts:variant', function (e) {
    var d = e.detail || {}, v = d.variant;
    document.querySelectorAll('[data-ch-stock][data-modo="real"][data-section="' + d.section + '"]').forEach(function (el) {
      var map = {};
      try { map = JSON.parse(el.querySelector('[data-ch-stock-map]').textContent); } catch (err) { return; }
      var q = v ? map[String(v.id)] : -1;
      var umbral = parseInt(el.getAttribute('data-umbral'), 10) || 0;
      if (typeof q !== 'number' || q < 1 || q > umbral) { el.hidden = true; return; }
      el.querySelector('[data-ch-stock-n]').textContent = q;
      el.hidden = false;
    });
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-block-ch-tallas"] && !Shopify.designMode) return;
  try {
    (function () {
  function init(root) {
    if (root.__ch) return; root.__ch = true;
    var json = root.querySelector('[data-ch-variants]');
    if (!json) return;
    var variants = JSON.parse(json.textContent);
    var section = root.getAttribute('data-section');
    var money = root.getAttribute('data-money');
    var grupos = Array.prototype.slice.call(root.querySelectorAll('.ch-var__group'));
    function elegidas() {
      return grupos.map(function (g) { var c = g.querySelector('input:checked'); return c ? c.value : null; });
    }
    function buscar(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) { if (opts[j] !== null && v.options[j] !== opts[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }
    function marcar() {
      var opts = elegidas();
      grupos.forEach(function (g, gi) {
        g.querySelectorAll('input').forEach(function (inp) {
          var t = opts.slice(); t[gi] = inp.value;
          var v = buscar(t);
          inp.closest('.ch-var__opt').classList.toggle('is-off', !v || !v.available);
        });
      });
    }
    function actualizar() {
      var v = buscar(elegidas());
      marcar();
      var scope = root.closest('product-info, .shopify-section') || document;
      if (v) {
        scope.querySelectorAll('form[data-ch-form] input[name="id"], form[data-ts-form] input[name="id"]').forEach(function (i) { i.value = v.id; });
        try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString()); } catch (e) {}
      }
      document.dispatchEvent(new CustomEvent('ts:variant', { detail: { variant: v, section: section, money: money } }));
    }
    root.addEventListener('change', function (e) { if (e.target.matches('.ch-var__in')) actualizar(); });
    marcar();
  }
  function boot() { document.querySelectorAll('[data-ch-var]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-block-ch-viendo"] && !Shopify.designMode) return;
  try {
    (function () {
  function rand(a, b) { return Math.floor(Math.random() * (b - a + 1)) + a; }
  function init(el) {
    if (el.__ch) return; el.__ch = true;
    if (el.getAttribute('data-modo') !== 'aleatorio') return;
    var min = parseInt(el.getAttribute('data-min'), 10) || 1, max = parseInt(el.getAttribute('data-max'), 10) || min;
    if (max < min) { var t = min; min = max; max = t; }
    var key = el.getAttribute('data-key'), n = el.querySelector('[data-ch-viewers-n]');
    var cur = null;
    try { cur = parseInt(localStorage.getItem(key), 10); } catch (e) {}
    if (!cur || cur < min || cur > max) cur = rand(min, max);
    function save() { try { localStorage.setItem(key, cur); } catch (e) {} }
    save();
    n.textContent = cur;
    function fluctuate() {
      cur = Math.min(max, Math.max(min, cur + (Math.random() < 0.55 ? 1 : -1)));
      save();
      n.style.opacity = '0';
      setTimeout(function () { n.textContent = cur; n.style.opacity = '1'; }, 300);
      setTimeout(fluctuate, rand(20000, 45000));
    }
    setTimeout(fluctuate, rand(20000, 45000));
  }
  function boot() { document.querySelectorAll('[data-ch-viewers]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-block-comprar"] && !Shopify.designMode) return;
  try {
    document.addEventListener('ts:variant', function (e) {
  var d = e.detail || {}, v = d.variant;
  document.querySelectorAll('[data-pb-buy][data-section="' + d.section + '"]').forEach(function (el) {
    var btn = el.querySelector('[data-pb-btn]'), txt = el.querySelector('[data-pb-btn-txt]');
    if (!v) { btn.disabled = true; txt.textContent = el.getAttribute('data-unavailable'); return; }
    btn.disabled = !v.available;
    txt.textContent = v.available ? el.getAttribute('data-add') : el.getAttribute('data-soldout');
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-block-envio"] && !Shopify.designMode) return;
  try {
    (function () {
  var DIAS = ['søn.', 'man.', 'tir.', 'ons.', 'tor.', 'fre.', 'lør.'];
  var MESES = ['jan.', 'feb.', 'mar.', 'apr.', 'maj', 'jun.', 'jul.', 'aug.', 'sep.', 'okt.', 'nov.', 'dec.'];
  function pintar() {
    document.querySelectorAll('[data-pb-envio]').forEach(function (el) {
      var out = el.querySelector('[data-pb-envio-fecha]');
      if (!out) return;
      var d = new Date();
      d.setDate(d.getDate() + (parseInt(el.getAttribute('data-dias'), 10) || 1));
      if (el.getAttribute('data-saltar-finde') === 'true') {
        if (d.getDay() === 6) d.setDate(d.getDate() + 2);
        else if (d.getDay() === 0) d.setDate(d.getDate() + 1);
      }
      out.textContent = DIAS[d.getDay()] + ' ' + d.getDate() + '. ' + MESES[d.getMonth()];
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pintar); else pintar();
  document.addEventListener('shopify:section:load', pintar);
  document.addEventListener('shopify:block:select', pintar);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-block-garantias"] && !Shopify.designMode) return;
  try {
    document.addEventListener('ts:variant', function (e) {
  var d = e.detail || {};
  document.querySelectorAll('[data-pb-gar][data-section="' + d.section + '"] [data-pb-stock]').forEach(function (row) {
    var map = {};
    (row.getAttribute('data-stock-map') || '').split(',').forEach(function (p) {
      var kv = p.split(':'); if (kv.length === 2) map[kv[0]] = parseInt(kv[1], 10);
    });
    var v = d.variant;
    var real = v && typeof map[String(v.id)] === 'number' ? map[String(v.id)] : 0;
    var umbral = parseInt(row.getAttribute('data-umbral'), 10) || 10;
    var smin = parseInt(row.getAttribute('data-min'), 10) || 3;
    var smax = parseInt(row.getAttribute('data-max'), 10) || 12;
    if (smax < smin) smax = smin;
    var dia = parseInt(row.getAttribute('data-dia'), 10) || 0;
    var sim = smin;
    if (v) sim = ((v.id % 99991) * 7 + dia) % (smax - smin + 1) + smin;
    var unidades = real > 0 ? real : sim;
    var ver = row.getAttribute('data-modo') === 'real' ? (real > 0 && real <= umbral) : true;
    row.hidden = !ver;
    if (ver) row.querySelector('[data-pb-stock-txt]').textContent = row.getAttribute('data-pb-stock').replace('[n]', unidades);
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-block-packs"] && !Shopify.designMode) return;
  try {
    (function () {
  function formFor(el) {
    var scope = el.closest('product-info, .shopify-section') || document;
    return scope.querySelector('form[data-ts-form]') || el.closest('form') || null;
  }
  function setQty(radio) {
    var form = formFor(radio);
    if (!form) return;
    var qty = form.querySelector('input[name="quantity"]');
    if (!qty) { qty = document.createElement('input'); qty.type = 'hidden'; qty.name = 'quantity'; form.appendChild(qty); }
    qty.value = radio.value;
  }
  document.addEventListener('change', function (e) {
    var r = e.target;
    if (!r || !r.matches || !r.matches('[data-pb-qty]')) return;
    var wrap = r.closest('.pb-packs');
    if (wrap) wrap.querySelectorAll('.pb-packs__bar').forEach(function (b) { b.classList.toggle('is-sel', b.contains(r)); });
    setQty(r);
  });
  function init() {
    document.querySelectorAll('.pb-packs [data-pb-qty]:checked').forEach(setQty);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('ts:variant', function (e) {
    var d = e.detail || {}, v = d.variant;
    if (!v || !window.tsMoney) return;
    var comp = v.compare_at_price && v.compare_at_price > v.price ? v.compare_at_price : v.price;
    document.querySelectorAll('[data-pb-packs][data-section="' + d.section + '"] .pb-packs__bar').forEach(function (bar) {
      var q = parseInt(bar.getAttribute('data-qty'), 10) || 1;
      var x = parseInt(bar.getAttribute('data-extra'), 10) || 0;
      var bruto = v.price * q, total = bruto - Math.floor(bruto * x / 100), full = comp * q;
      bar.querySelector('[data-pb-total]').textContent = window.tsMoney(total, d.money);
      var f = bar.querySelector('[data-pb-full]');
      f.textContent = window.tsMoney(full, d.money);
      f.hidden = !(full > total);
    });
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-block-precio"] && !Shopify.designMode) return;
  try {
    document.addEventListener('ts:variant', function (e) {
  var d = e.detail || {}, v = d.variant;
  if (!v || !window.tsMoney) return;
  document.querySelectorAll('[data-pb-precio][data-section="' + d.section + '"]').forEach(function (el) {
    var sale = v.compare_at_price && v.compare_at_price > v.price;
    el.classList.toggle('is-plain', !sale);
    el.querySelector('[data-pb-sale]').textContent = window.tsMoney(v.price, d.money);
    el.querySelector('[data-pb-compare]').textContent = sale ? window.tsMoney(v.compare_at_price, d.money) : '';
    var b = el.querySelector('[data-pb-badge]');
    if (b && sale) b.textContent = el.getAttribute('data-label') + ' ' + Math.floor((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%';
  });
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-block-variantes"] && !Shopify.designMode) return;
  try {
    (function () {
  window.tsMoney = window.tsMoney || function (cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var f = format || ('€' + String.fromCharCode(123, 123) + 'amount_with_comma_separator' + String.fromCharCode(125, 125));
    var re = /\{\{\s*(\w+)\s*\}\}/;
    function n(c, p, t, d) {
      p = p == null ? 2 : p; t = t == null ? ',' : t; d = d == null ? '.' : d;
      if (c == null || isNaN(c)) return '0';
      var parts = (c / 100).toFixed(p).split('.');
      return parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + t) + (parts[1] ? d + parts[1] : '');
    }
    var m = f.match(re); if (!m) return f;
    var v;
    switch (m[1]) {
      case 'amount_no_decimals': v = n(cents, 0); break;
      case 'amount_with_comma_separator': v = n(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = n(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = n(cents, 2, "'", '.'); break;
      case 'amount_with_space_separator': v = n(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': v = n(cents, 0, ' ', ','); break;
      default: v = n(cents, 2);
    }
    return f.replace(re, v);
  };

  function init(root) {
    if (root.__ts) return; root.__ts = true;
    var json = root.querySelector('[data-ts-variants]');
    if (!json) return;
    var variants = JSON.parse(json.textContent);
    var section = root.getAttribute('data-section');
    var money = root.getAttribute('data-money');
    var grupos = Array.prototype.slice.call(root.querySelectorAll('.pb-var__grupo'));

    function elegidas() {
      return grupos.map(function (g) { var c = g.querySelector('input:checked'); return c ? c.value : null; });
    }
    function buscar(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i], ok = true;
        for (var j = 0; j < opts.length; j++) { if (opts[j] !== null && v.options[j] !== opts[j]) { ok = false; break; } }
        if (ok) return v;
      }
      return null;
    }
    function marcarDisponibles() {
      var opts = elegidas();
      grupos.forEach(function (g, gi) {
        g.querySelectorAll('input').forEach(function (inp) {
          var t = opts.slice(); t[gi] = inp.value;
          var v = buscar(t);
          inp.closest('.pb-var__opt').classList.toggle('is-off', !v || !v.available);
        });
        var sel = g.querySelector('[data-ts-sel]');
        if (sel) sel.textContent = opts[gi] || '';
      });
    }
    function actualizar() {
      var v = buscar(elegidas());
      marcarDisponibles();
      var scope = root.closest('product-info, .shopify-section') || document;
      if (v) {
        scope.querySelectorAll('form[data-ts-form] input[name="id"]').forEach(function (i) { i.value = v.id; });
        try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); window.history.replaceState({}, '', u.toString()); } catch (e) {}
      }
      document.dispatchEvent(new CustomEvent('ts:variant', { detail: { variant: v, section: section, money: money } }));
    }
    root.addEventListener('change', function (e) { if (e.target.matches('.pb-var__in')) actualizar(); });

    marcarDisponibles();
  }
  function boot() { document.querySelectorAll('[data-ts-var]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ts-galeria"] && !Shopify.designMode) return;
  try {
    (function () {
  function init(root) {
    if (root.__ts) return; root.__ts = true;
    var track = root.querySelector('[data-ts-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('.ts-gal__slide'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-ts-thumb]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-ts-dot]'));
    var actual = 0;

    function marcar(i) {
      actual = i;
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      var t = thumbs[i];
      if (t && t.parentElement.scrollHeight > t.parentElement.clientHeight) {
        var p = t.parentElement;
        if (t.offsetTop < p.scrollTop || t.offsetTop + t.offsetHeight > p.scrollTop + p.clientHeight) p.scrollTo({ top: t.offsetTop - 10, behavior: 'smooth' });
      }
    }
    function ir(i, suave) {
      if (!slides[i]) return;
      track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: suave === false ? 'auto' : 'smooth' });
      marcar(i);
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { ir(parseInt(t.getAttribute('data-ts-thumb'), 10)); }); });
    dots.forEach(function (d) { d.addEventListener('click', function () { ir(parseInt(d.getAttribute('data-ts-dot'), 10)); }); });
    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
        if (i !== actual) marcar(i);
      });
    }, { passive: true });

    var tw = root.querySelector('[data-ts-thumbs]');
    function alto() { if (tw) tw.style.maxHeight = track.clientHeight ? track.clientHeight + 'px' : ''; }
    alto(); window.addEventListener('resize', alto);
    root.querySelectorAll('.ts-gal__img').forEach(function (im) { if (!im.complete) im.addEventListener('load', alto, { once: true }); });

    var inicial = root.querySelector('.ts-gal__thumb.is-active');
    if (inicial) ir(parseInt(inicial.getAttribute('data-ts-thumb'), 10), false);

    document.addEventListener('ts:variant', function (e) {
      var d = e.detail || {}, v = d.variant;
      if (d.section !== root.getAttribute('data-section') || !v || !v.featured_media) return;
      for (var k = 0; k < slides.length; k++) {
        if (String(slides[k].getAttribute('data-media-id')) === String(v.featured_media.id)) { ir(k); break; }
      }
    });

    // Ampliacion
    var lb = root.querySelector('[data-ts-lb]'), lbImg = root.querySelector('[data-ts-lb-img]');
    if (lb) document.body.appendChild(lb);
    var zooms = Array.prototype.slice.call(root.querySelectorAll('[data-ts-zoom]'));
    var zi = 0;
    function abrir(k) { zi = k; lbImg.src = zooms[k].getAttribute('data-full'); lb.hidden = false; document.documentElement.style.overflow = 'hidden'; }
    function cerrar() { lb.hidden = true; lbImg.removeAttribute('src'); document.documentElement.style.overflow = ''; }
    function mover(n) { if (!zooms.length) return; abrir((zi + n + zooms.length) % zooms.length); }
    zooms.forEach(function (z, k) { z.addEventListener('click', function () { abrir(k); }); });
    lb.querySelector('[data-ts-lb-close]').addEventListener('click', cerrar);
    lb.querySelector('[data-ts-lb-prev]').addEventListener('click', function () { mover(-1); });
    lb.querySelector('[data-ts-lb-next]').addEventListener('click', function () { mover(1); });
    lb.addEventListener('click', function (e) { if (e.target === lb) cerrar(); });
    document.addEventListener('keydown', function (e) {
      if (lb.hidden) return;
      if (e.key === 'Escape') cerrar();
      if (e.key === 'ArrowLeft') mover(-1);
      if (e.key === 'ArrowRight') mover(1);
    });
  }
  function boot() { document.querySelectorAll('[data-ts-gal]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
  } catch(e) { console.error(e); }
})();

})();
